// extracted by mini-css-extract-plugin
export default {"Wrapper":"Wrapper_Wrapper__3Mn72","full":"Wrapper_full__ZO5ii"};